import '@babel/polyfill'
import 'mutationobserver-shim'
import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag-next";
import router, { setupRouterNavigationGuards } from "./router";

// styling
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// import "./styles/calantic.scss";
import "./styles/layout.scss";
// import "./styles/components.scss";

// services
import IAuthenticationService from "./interfaces/authentication_service";
import ITuneSelectorService from './interfaces/tune_selector_service';
import configureContainer from "./di/configure_container";

// components
import RegionFilter from "./components/region_filter.vue";
import TrackList from "./components/track_list.vue";
import GradeFilter from "./components/grade_filter.vue";
import DanceFilter from "./components/dance_filter.vue";
import SetDanceTypeFilter from "./components/set_dance_type_filter.vue"
import SetDanceFilter from "./components/set_dance_filter.vue"
import SetDances from "./components/set_dances.vue"
import Biography from "./components/bio.vue";
import ComingSoon from "./components/coming_soon.vue";
import IConfigurationService from './interfaces/configuration_service';

const container = configureContainer();

// setup Vue
const app = createApp(App)

setupRouterNavigationGuards(container);

app.use(router);
app.use(VueGtag, {
	property: {
		id: "G-PCCCDX8YCT"
	}
//,
  //useDebugger: true
  });

// register services. the services can be injected into Vue components using the composition API
// https://v3.vuejs.org/guide/composition-api-provide-inject.html
app.provide(
	"authenticationService",
	container.getNamed<IAuthenticationService>(
		Symbol.for("IAuthenticationService"),
		"AuthenticationService"
	)
);

app.provide(
	"configurationService",
	container.getNamed<IConfigurationService>(
		Symbol.for("IConfigurationService"),
		"ConfigurationService"
	)
);

app.provide(
	"TuneSelectorService",
	container.getNamed<ITuneSelectorService>(
		Symbol.for("ITuneSelectorService"),
		"TuneSelectorService"
	)
);

// setup global components
app.component("region-filter", RegionFilter);
app.component("track-list", TrackList);
app.component("grade-filter", GradeFilter);
app.component("dance-filter", DanceFilter);
app.component("set-dance-type-filter", SetDanceTypeFilter);
app.component("set-dance-filter", SetDanceFilter);
app.component("set-dances", SetDances);
app.component("biography", Biography);
app.component("coming-soon", ComingSoon);
// OTHER STUFF


app.mount('#app')
